import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const DASHBOARD_METRICS = {
  bandwidth: 'anchodebanda',
  memory: 'memoria',
  cpu: 'cpu',
  responseTime: 'tiempoderespuesta',
  availability: 'disponibilidad',
};

export const DASHBOARD_FILTERS = {
  regions: 'regiones',
  inmuebles: 'inmuebles',
  groups: 'grupos',
};

export const NODE_STATES = {
  0: '#F44336',
  1: '#ffa640',
  2: '#27a027',
  3: '#999693',
  4: '#000000',
};

export const NODES_WORD_STATE = {
  rojo: '#F44336',
  amarillo: '#ffa640',
  verde: '#32cd32',
  gris: '#999693',
};

export const setProgressBarColor = (progressValue, type, currentMetricThresholds) => {
  if (['disponibilidad', 'powersupply'].includes(type)) {
    if (progressValue === 0) return ['error', '#F44336'];
    if (!progressValue) return [null, null];
    if (progressValue > currentMetricThresholds[type].success) {
      return ['success', '#2E7D32'];
    }
    if (progressValue >= currentMetricThresholds[type].warning) {
      return ['warning', '#ffa640'];
    }
    return ['error', '#F44336'];
  }

  if (!progressValue && progressValue !== 0) return ['success', '#2E7D32'];
  if (progressValue <= currentMetricThresholds[type].success) {
    return ['success', '#2E7D32'];
  }
  if (progressValue < currentMetricThresholds[type].warning) {
    return ['warning', '#ffa640'];
  }
  return ['error', '#F44336'];
};

export const metricThresholds = {
  memoria: {
    success: 79,
    warning: 90,
  },
  cpu: {
    success: 79,
    warning: 90,
  },
  disponibilidad: { // Especial Caso
    success: 90,
    warning: 80,
  },
  jitter: {
    success: 79,
    warning: 90,
  },
  latencia: {
    success: 499,
    warning: 1000,
  },
  paquetes: {
    success: 29,
    warning: 50,
  },
  bandwidth: {
    success: 90,
    warning: 96,
  },
  temperatura: {
    success: 40,
    warning: 51,
  },
  powersupply: { // Especial Caso
    success: 80,
    warning: 70,
  },
  mos: {
    success: 4, // Especial Caso
    warning: 3,
  }
};

const metricsCatalog = {
  1: 'memoria',
  2: 'cpu',
  4: 'latencia',
  5: 'paquetes',
  6: 'temperatura',
  7: 'powersupply',
  8: 'jitter',
  10: 'disponibilidad',
  12: 'bandwidth',
};

export const getMetricThresholds = async () => {
  try {
    const response = await axios.get(`${API_URL}/ms-catalogos/filtros/umbral`);
    const metricsResponse = response.data;
    const newMetricThresholds = { ...metricThresholds };
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < metricsResponse.length; i++) {
      if (metricsResponse[i]?.metricaLectura?.id in metricsCatalog) {
        if (['disponibilidad', 'powersupply'].includes(metricsCatalog[metricsResponse[i]?.metricaLectura?.id])) {
          if (metricsResponse[i]?.color === 'verde') {
            newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]] = {
              ...newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]],
              success: metricsResponse[i]?.umbralMin,
            };
          }
          if (metricsResponse[i]?.color === 'amarillo') {
            newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]] = {
              ...newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]],
              warning: metricsResponse[i]?.umbralMin,
            };
          }
        } else {
          if (metricsResponse[i]?.color === 'verde') {
            newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]] = {
              ...newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]],
              success: metricsResponse[i]?.umbralMax,
            };
          }
          if (metricsResponse[i]?.color === 'amarillo') {
            newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]] = {
              ...newMetricThresholds[metricsCatalog[metricsResponse[i]?.metricaLectura?.id]],
              warning: metricsResponse[i]?.umbralMax + 1,
            };
          }
        }
      }
      
    }
    return newMetricThresholds;
  } catch (error) {
    return metricThresholds;
  }
};

// estadoEquipo: {
//   0: '#F44336',
//   1: '#ED6C02',
//   2: '#2E7D32',
//   3: '#D3D5D6',
// },
